import FetchUtils from 'src/utils/fetch_utils';

/**
 * Init pet screening button: POST to sendPetScreeningUrl, replace button with "Pet Screening Request Sent" on success.
 */
export function initPetScreening(button) {
  if (button.dataset.bound === 'true') {
    return;
  }

  button.dataset.bound = 'true';
  button.addEventListener('click', (e) => {
    e.preventDefault();
    const url = button.dataset.sendPetScreeningUrl;
    if (!url) {
      return;
    }

    fetch(url, {
      method: 'POST',
      headers: {
        'x-csrf-token': FetchUtils.CSRFToken()
      }
    })
      .then(FetchUtils.checkResponseStatus)
      .then((resp) => resp.json())
      .then((response) => {
        if (response.success) {
          button.replaceWith('Pet Screening Request Sent');
        }
      })
      .catch((err) => {
        FetchUtils.handleResponseError(err);
      });
  });
}
